var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClockCircularOutline = function SvgClockCircularOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.505,
    height: 11.505,
    viewBox: "0 0 11.505 11.505",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.753,0a5.753,5.753,0,1,0,5.753,5.753A5.759,5.759,0,0,0,5.753,0Zm0,10.248a4.5,4.5,0,1,1,4.5-4.5A4.5,4.5,0,0,1,5.753,10.248Z",
    fill: "#00ddff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257.764,142.153v-2.411a.487.487,0,1,0-.975,0v2.567c0,.008,0,.015,0,.023a.485.485,0,0,0,.14.368l1.815,1.815a.487.487,0,0,0,.689-.689Z",
    transform: "translate(-251.513 -136.394)",
    fill: "#00ddff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClockCircularOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock-circular-outline.da098ff3.svg";
export { ForwardRef as ReactComponent };